import * as React from "react";
import { forwardRef } from "react";
const SvgLightningIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "lightning") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M15,6H8.4l1.6-4.7c0.3-1-0.9-1.8-1.7-1l-8,8C-0.3,8.9,0.1,10,1,10h6.6l-1.6,4.7c-0.3,1,0.9,1.8,1.7,1l8-8 C16.3,7.1,15.9,6,15,6z" })));
const ForwardRef = forwardRef(SvgLightningIcon);
export { ForwardRef as ReactComponent };
